import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, colors } from '@mui/material';
// components
import { BaseOptionChart } from '../../components/chart';

// ----------------------------------------------------------------------

ServerUtilization.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function ServerUtilization({ title, xtittle, ytittle, subheader, chartLabels, chartData, chartcolors, ...other }) {
  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '16%', } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: chartLabels,
    colors: chartcolors,
    yaxis: {
      title: {
        text: ytittle
      },
    },
    xaxis: {
      title: {
        text: xtittle
      },
    },
    // xaxis: { type: 'datetime' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} `;
          }
          return y;
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box dir="ltr">
        <ReactApexChart type="line" series={chartData} options={chartOptions} height={500} />
      </Box>
    </Card>
  );
}
